import OrderTableColumnsType from "../enum/OrderTableColumnsType";

const OrderTableColumnsTypeNameMap = {
    [OrderTableColumnsType.STATUS]: "状态",
    [OrderTableColumnsType.SHOP_INFO]: "店铺",
    [OrderTableColumnsType.ORIGINAL_ID]: "订单编号",
    [OrderTableColumnsType.RETAILER]: "代理商",
    [OrderTableColumnsType.BUYER_USERNAME]: "买家昵称",
    [OrderTableColumnsType.QUANTITY]: "数量",
    [OrderTableColumnsType.PAYMENTS]: "实付",
    [OrderTableColumnsType.PRODUCT]: "商品",
    [OrderTableColumnsType.CUSTOMIZATION_INFO]: "定制信息",
    [OrderTableColumnsType.ORDER_TIME]: "下单时间",
    [OrderTableColumnsType.PAYMENT_TIME]: "付款时间",
    [OrderTableColumnsType.INVOICE_INFO]: "发票信息",
    [OrderTableColumnsType.SHIPPING_DEADLINE]: "剩余(最后)发货时间",
    [OrderTableColumnsType.CONSIGNEE]: "收货人",
    [OrderTableColumnsType.ORDER_REMARK]: "留言备注",
    [OrderTableColumnsType.SHIPPING_TIME]: "发货时间",
    [OrderTableColumnsType.WAYBILL_NO]: "运单号",
    [OrderTableColumnsType.SUPPLIER_DROPSHIPPING2]: "代发信息",
    [OrderTableColumnsType.SEQUENCE_NO]: "打印流水号",
    [OrderTableColumnsType.WEIGHT]: "订单重量",
    [OrderTableColumnsType.SHIPPER]: "发货人",
    [OrderTableColumnsType.LOGISTICS_AGING_PREDICT]: "预估配送时效",
    [OrderTableColumnsType.LOGISTICS_RECOMMEND]: "快递推荐",
    [OrderTableColumnsType.SELLER_RECEIPTS]: "实收",
    [OrderTableColumnsType.QUICK_OPERATION]: "单打操作",
};

export default OrderTableColumnsTypeNameMap;
